import { useEffect, useRef, useState, type ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { currentEmbeddedApp, postOpenPlans } from '@/lib/app-embed/readEmbeddedApp';

/** In the mobile app the plans live in the native Planos tab: hand off and
 *  step back. Without the bridge, or on the web, the page renders as usual. */
export const EmbeddedPlansGuard = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  // 'default' marks the first entry of the history: nothing to go back to.
  const firstEntry = useLocation().key === 'default';
  const [embedded] = useState(() => currentEmbeddedApp() !== null);
  const [handedOff, setHandedOff] = useState(embedded);
  const posted = useRef(false);

  useEffect(() => {
    if (!embedded || posted.current) return;
    posted.current = true;
    if (postOpenPlans()) {
      if (firstEntry) navigate('/', { replace: true });
      else navigate(-1);
    }
    else setHandedOff(false);
  }, [embedded, navigate, firstEntry]);

  return handedOff ? null : <>{children}</>;
};

export default EmbeddedPlansGuard;
